export interface Module {
  label: string
  title: string
  body: string
  tagline: string
  color: string
}

export const modules: Module[] = [
  {
    label: '✅ MODULE 1',
    title: 'GASOLINE ENGINE FUNDAMENTALS & DIAGNOSTIC PROCESS',
    body: 'Build a structured foundation for gasoline engine fault finding. Understand combustion, engine management, OBD-II, symptoms, DTCs, freeze-frame data and the diagnostic process through organized diagrams, references and troubleshooting workflows.',
    tagline: 'Inspect. Understand. Diagnose.',
    color: '#1E4FA8',
  },
  {
    label: '✅ MODULE 2',
    title: 'FUEL DELIVERY & FUEL INJECTION DIAGNOSTICS',
    body: 'Diagnose gasoline fuel-system problems through a structured testing process. Explore fuel pumps, pressure, fuel rails, PFI and GDI systems, injectors, electrical controls, rich and lean conditions and fuel-delivery faults through practical diagnostic references.',
    tagline: 'Measure. Test. Verify.',
    color: '#C8202A',
  },
  {
    label: '✅ MODULE 3',
    title: 'IGNITION SYSTEM & MISFIRE DIAGNOSTICS',
    body: 'Identify ignition and misfire problems without immediately replacing parts. Explore spark plugs, coils, ignition signals, cylinder-specific and random misfires, scan data and testing procedures through structured comparisons and diagnostic paths.',
    tagline: 'Identify. Compare. Isolate.',
    color: '#D9730F',
  },
  {
    label: '✅ MODULE 4',
    title: 'AIR INTAKE, SENSORS & ENGINE MANAGEMENT',
    body: 'Understand how airflow, sensors and electronic engine management affect gasoline engine operation. Explore MAF, MAP, TPS, APP, ECT, IAT, CKP, CMP, O2/A/F sensors, vacuum leaks, throttle control and live-data relationships through organized diagnostic references.',
    tagline: 'Read. Compare. Diagnose.',
    color: '#1F8A4C',
  },
  {
    label: '✅ MODULE 5',
    title: 'EMISSIONS, VVT & DRIVABILITY DIAGNOSTICS',
    body: 'Troubleshoot the systems behind many difficult drivability complaints. Explore EVAP, PCV, catalyst operation, oxygen-sensor feedback, VVT, timing relationships, rough idle, hesitation, stalling, power loss and excessive fuel consumption.',
    tagline: 'Observe. Test. Troubleshoot.',
    color: '#6B3FB5',
  },
  {
    label: '✅ MODULE 6',
    title: 'ADVANCED DIAGNOSTICS, TESTING & REAL-WORLD CASES',
    body: 'Bring scan data, electrical testing and mechanical testing together. Work through multimeter tests, oscilloscope patterns, compression, leak-down, vacuum analysis, intermittent faults and structured cases covering common gasoline-engine problems.',
    tagline: 'Analyze. Test. Confirm.',
    color: '#4A5058',
  },
]
